<script lang="ts">
import CardLayout from "$items/CardLayout.svelte";
import InfoBox from "$items/InfoBox.svelte";
import CardLayoutSubmitButton from "$items/employee/form/CardLayoutSubmitButton.svelte";
import {getReference} from "$lib/calls/hr";
import {onMount} from "svelte";
export let customer;

$: address = customer.address
let countries = [];
onMount(async () => {
    countries = (await getReference('Staaten')).map(x => ({...x, name: x.value}))
})
</script>

<CardLayout title="Kontakt">
    <form class="flex flex-col gap-3" method="post" action="?/saveClientAddress">
        <input type="hidden" name="customerUuid" value={customer.uuid}/>
        <input type="hidden" name="uuid" value={address.uuid}/>
        <div class="flex gap-2">
            <InfoBox placeholder="Strasse" value={address.street} name="street"></InfoBox>
            <InfoBox placeholder="Hausnummer" value={address.number} name="number"></InfoBox>
        </div>
        <div class="flex gap-2">
            <InfoBox placeholder="Ort" value={address.place} name="place"></InfoBox>
            <InfoBox placeholder="PLZ" value={address.zip} name="zip"></InfoBox>
        </div>
        <InfoBox type="select" items={countries} value={address.country} name="country"></InfoBox>
        <CardLayoutSubmitButton/>
    </form>


</CardLayout>